// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Modal from "@insite/mobius/Modal";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { createBuyingList } from "@store/Framework/Services/RestrictedBuyingListService";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import Button from "@store/MobiusOverrides/Button/Button";
import { ButtonProps } from "@store/MobiusOverrides/Button/Props";
import MyListsEditListForm from "@store/MobiusOverrides/MyLists/MyListsEditListForm";
import React from "react";
import { css } from "styled-components";

export interface BuyingListManagementButtonstyles {
    newListButton: ButtonProps;
}

export const buyingListManagementButtonstyles: BuyingListManagementButtonstyles = {
    newListButton: {
        variant: "secondary" as const,
        css: css`
            // need to match height of search box to align buttons
            height: 44px;
        `,
    },
};
const BuyingListManagementCreateUserButton = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { getBuyingLists, loading } = useBuyingList();
    const handleSubmit = () => {
        setIsModalOpen(false);
        getBuyingLists(true);
    };
    return (
        <>
            <Button
                {...buyingListManagementButtonstyles.newListButton}
                disabled={loading}
                onClick={() => setIsModalOpen(true)}
                mergeCss
                data-test-selector="buyingListManagementCreate_newListButton"
            >
                {translate("Create List")}
            </Button>
            <Modal
                headline={translate("Create List")}
                sizeVariant="small"
                isOpen={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                data-test-selector="buyingListManagementCreate_modal"
            >
                <MyListsEditListForm
                    onCancel={() => setIsModalOpen(false)}
                    onSubmit={handleSubmit}
                    createBuyingList={createBuyingList}
                    data-test-selector="buyingListManagementCreate_editForm"
                ></MyListsEditListForm>
            </Modal>
        </>
    );
};

const widgetModule: CustomWidgetModule = {
    component: BuyingListManagementCreateUserButton,
    definition: {
        group: "Buying List",
    },
};

export default widgetModule;
